import React, { useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import * as auth from "infra/localStorage.js"
import server from 'infra/server'
import LoginService from './loginService'
import { errorToToast } from 'helper/error'

export default function Login() {

    const [loginService] = useState(new LoginService())
    const { state } = useLocation()
    const [message, setMessage] = useState('')

    const navigate = useNavigate()
    const toast = useRef(null)
    const { msgRegistered } = state || ""
    const passwordInputRef = useRef(null)
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 768 || window.innerHeight < 420)
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])


    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (msgRegistered && msgRegistered.length > 0) {
            setMessage(msgRegistered)
        }
    }, [msgRegistered])

    useEffect(() => {
        document.body.style.backgroundColor = '#ffffff'
        return () => {
            document.body.style.backgroundColor = ''
        }
    }, [])

    const defaultValues = []

    const form = useForm({ defaultValues })
    const errors = form.formState.errors

    const onSubmit = async (data) => {

        if (data.email && data.password) {

            const storageData = auth.getData()

            const http = server()
            setLoading(true)

            http.post('login', {
                "loginUsu": data.email,
                "password": data.password
            }
            ).then((response) => {

                // Logou

                storageData.token = response.data.token
                auth.setData(storageData)

                // Busca [Base] e [Empresa]
                server().get('sessaoinfo').then(async (response) => {

                    const dataInfo = response.data[0]

                    storageData.usuario.nome_usu = dataInfo.nome_usu
                    storageData.usuario.email_usu = dataInfo.login_usu
                    storageData.base.codnum_bad = dataInfo.codnum_bad
                    storageData.base.descricao_bad = dataInfo.descricao_bad
                    storageData.empresa.codigo_emp = dataInfo.cod_emp_ten_log_ses
                    storageData.base.bucket_bad = dataInfo.bucket_bad
                    storageData.bucketPath = dataInfo.bucketPath

                    auth.setData(storageData)

                    if (!storageData.base.codnum_bad) { // Se vazio é proque tem mais de uma base
                        navigate('/base')
                    } else if (!storageData.empresa.codigo_emp) { // Se vazio é porque tem mais de uma empresa
                        navigate('/empresa')
                    } else {

                        /**
                         *  Esse getMenu deve ser chamado dentro de /base e /empresa caso entre nesses Ifs
                         */
                        storageData.menu = await loginService.getMenu()

                        auth.setData(storageData)

                        // Busca a descrição da empresa
                        server().get('empresa').then((response) => {

                            const selectEmp = response.data.find((e) => e.codigo_emp == storageData.empresa.codigo_emp)
                            storageData.empresa.nome_razao_pes = selectEmp.nome_razao_pes
                            storageData.empresa.nome_fantasia_pej = selectEmp.nome_fantasia_pej
                            auth.setData(storageData)

                            navigate('/')

                        })

                    }
                })

            }).catch(err => {
                errorToToast({ err, toast, alt: 'Erro desconhecido ao fazer login!' })
                setLoading(false)
            })


        }

    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    return (
        <div className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0">
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center z-1`}>

                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>

                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">

                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Entrar</div>
                        </h2>

                        {message && <div className='fadeinleft text-logo-main mb-3'>
                            {message}
                        </div>}

                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column gap-1 w-20rem border-0">

                            {/* Email */}
                            <Controller
                                name="email"
                                control={form.control}
                                rules={{ required: 'E-mail obrigatório' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <div className="flex items-center gap-2 border-2 border-solid border-round-2xl border-logo-main bg-white w-20rem px-3 py-2">
                                            {/* Ícone à esquerda */}
                                            <i
                                                className="pi pi-user text-logo-main cursor-pointer"
                                                onClick={() => passwordInputRef.current?.focus()}
                                            ></i>

                                            {/* Input */}
                                            <input
                                                {...field}
                                                id='email'
                                                name='email'
                                                type='email'
                                                placeholder="Usuário"
                                                autoComplete="on"
                                                className="flex-1 border-none outline-none bg-transparent text-gray-700 appearance-none text-base"
                                                style={{ backgroundColor: 'transparent' }}
                                            />

                                        </div>
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />

                            {/* Senha */}
                            <Controller
                                name="password"
                                control={form.control}
                                rules={{ required: 'Senha obrigatória' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <div className="flex items-center gap-2 border-2 border-solid border-round-2xl border-logo-main bg-white w-20rem px-3 py-2">
                                            {/* Ícone à esquerda */}
                                            <i
                                                className="pi pi-lock text-logo-main cursor-pointer"
                                                onClick={() => passwordInputRef.current?.focus()}
                                            ></i>

                                            {/* Input */}
                                            <input
                                                {...field}
                                                id='password'
                                                ref={passwordInputRef}
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="Senha"
                                                autoComplete="on"
                                                className="flex-1 border-none outline-none bg-transparent text-gray-700 appearance-none text-base"
                                                style={{ backgroundColor: 'transparent' }}
                                            />

                                            {/* Ícone à direita */}
                                            <i
                                                className={`pi ${showPassword ? 'pi-eye-slash' : 'pi-eye'} text-logo-main cursor-pointer`}
                                                onClick={() => setShowPassword(prev => !prev)}
                                            ></i>
                                        </div>
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />

                            {/* Botão */}
                            <Button id='btnLogin' label="Entrar" type="submit" icon={loading ? "pi pi-spin pi-cog" : ""}
                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl"
                            />

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link itemID='newAccount' id='newAccount' to="/register" className="text-logo-main no-underline">Criar conta</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div >
    )


}
